import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { routeModule, permCan } from "@/lib/constants";

const SKIP = new Set(["dashboard"]);
const B = (w) => new RegExp(`(^|[-_])(${w})([-_]|$)`);
const RULES = [
  ["delete", B("delete|remove|rm"), /^supprimer/, /lucide-trash/],
  ["validate", B("validate|approve"), /^(valider|approuver)/, null],
  ["edit", B("edit"), /^modifier/, /lucide-(pencil|square-pen|pen-line|file-pen)/],
  ["create", /^(add|new|create)([-_]|$)|[-_](add|new|create)([-_]|$)/, /^(nouveau|nouvelle|ajouter|créer|\+ )/, null],
];

const actionOf = (el) => {
  const tid = (el.getAttribute("data-testid") || "").toLowerCase();
  const txt = (el.textContent || "").trim().toLowerCase();
  const svg = (el.querySelector("svg")?.getAttribute("class") || "").toLowerCase();
  for (const [a, rt, rx, ri] of RULES) {
    if ((tid && rt.test(tid)) || (txt && rx.test(txt)) || (ri && !txt && ri.test(svg))) return a;
  }
  return null;
};

// Masque les boutons Créer / Modifier / Supprimer / Valider non autorisés pour le module de la page courante.
export function PermGuard() {
  const { pathname } = useLocation();
  const { permissions, role } = useAuth();
  useEffect(() => {
    const mod = routeModule(pathname);
    const reset = () => document.querySelectorAll("[data-perm-hidden]").forEach((el) => { el.style.display = ""; el.removeAttribute("data-perm-hidden"); });
    reset();
    if (!mod || SKIP.has(mod) || role === "super_admin") return reset;
    const deny = new Set(["create", "edit", "delete", "validate"].filter((a) => !permCan(permissions, mod, a)));
    if (!deny.size) return reset;
    const scan = () => {
      document.querySelectorAll("button, [role=menuitem], a[data-testid]").forEach((el) => {
        if (el.hasAttribute("data-perm-hidden") || el.closest("header, aside, nav, [data-perm-ignore]")) return;
        const a = actionOf(el);
        if (a && deny.has(a)) { el.style.display = "none"; el.setAttribute("data-perm-hidden", a); }
      });
    };
    scan();
    const obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); reset(); };
  }, [pathname, permissions, role]);
  return null;
}
